import React from 'react';

const STEPS = [
  { key: 'new', label: 'New' },
  { key: 'meeting_scheduled', label: 'Meeting' },
  { key: 'in_review', label: 'Review' },
  { key: 'need_info', label: 'Need Info' },
  { key: 'conditionally_approved', label: 'Conditional' },
  { key: 'approved', label: 'Approved' },
];

export default function HOATrack({ status }) {
  const idx = Math.max(0, STEPS.findIndex(s => s.key === status));
  
  // Handle rejected/closed status
  const isRejected = status === 'rejected' || status === 'closed';
  const displayIdx = isRejected ? -1 : idx;
  
  return (
    <div className="w-full">
      <div className={`relative h-3 rounded-full ${isRejected ? 'bg-red-400' : 'bg-gradient-to-r from-red-400 via-yellow-300 to-green-500'}`} />
      <div className="flex justify-between mt-2">
        {STEPS.map((s, i) => (
          <div key={s.key} className="text-[10px] sm:text-xs text-gray-600 flex-1 text-center">
            <div className={`mx-auto w-2 h-2 rounded-full ${
              isRejected 
                ? 'bg-red-500' 
                : i <= displayIdx 
                  ? 'bg-green-600' 
                  : 'bg-gray-300'
            }`} />
            <div className={`mt-1 ${i === displayIdx ? 'font-semibold text-gray-900' : ''}`}>
              {s.label}
            </div>
          </div>
        ))}
      </div>
      {isRejected && (
        <div className="text-center mt-2">
          <span className="text-xs text-red-600 font-semibold">
            {status === 'rejected' ? 'Rejected' : 'Closed'}
          </span>
        </div>
      )}
      {status === 'approved' && (
        <div className="text-center mt-2">
          <span className="text-sm text-green-600 font-bold">
            🎉 Congratulations, Approved! 🎉
          </span>
        </div>
      )}
    </div>
  );
}